<div class="h-full">
  <textarea [hidden]="tinyMceInitiated" rows="2" id="textEditor" class="w-full border-2 rounded-lg p-2" placeholder="{{'placeholder.type_your_note' | translate}}" (focus)="showEditor()"></textarea>
  <div class="relative h-full w-full">
    <editor
      *ngIf="tinyMceInitiated"
       [init]="getConfig"
       [formControl] = "editorData"
       class="form-control h-full"
     ></editor>
     <div 
     [class]="options?.isFullScreen ? 'absolute -top-[52px] right-14 z-50 flex justify-end p-1 emailTemplate' : 'absolute top-32 z-10 w-52 right-2 flex justify-end p-1 emailTemplate'"
     id="emailTemplate" 
     *ngIf="tinyMceInitiated && this.options.showTemplate && dropDownValues?.length > 0"
     (mousedown)="$event.preventDefault(); $event.stopPropagation()"
     >
      <ng-select 
              #ngSelect
              ngClass="w-full" 
              appearance="fill" 
              [items]="dropDownValues"
              id="suggestedFields"
              name="suggestedFields"
              class="form-control" 
              #operator="ngModel"
              appendTo="body"
              bindLabel="template_name"
              bindValue="template_uid"
              placeholder="{{'text.choose_template.header' | translate}}"
              [clearable]="true"
              [multiple]="false"
              [(ngModel)]="templateID"
              (change)="onTemplateChange($event)"
              >
              <ng-template ng-label-tmp let-item="item">
                <span class="flex items-center space-x-2">
                  <i class="ti ti-mail-filled"></i>  <!-- Prefix icon in the label -->
                  <span class="flex items-center mt-0.5 text-base primary-font">
                    {{ item.template_name }}
                  </span>
                </span>
              </ng-template>
              
              <!-- Custom template for the options in the dropdown -->
              <ng-template ng-option-tmp let-item="item">
                <span class="flex justify-start items-center text-base primary-font space-x-2">
                  {{ item.template_name }}
                </span>
              </ng-template>
      </ng-select>
    </div>
  </div>
</div>